import {clx} from '@hm/fundamental'
import {useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {ShutdownDetailInfoSummary} from './ShutdownDetailInfoSummary'
import {ShutdownDetailInfoTable} from './ShutdownDetailInfoTable'

import {StaticPartsColors} from '@refra/modules/refra-static-parts/enums'
import {useReplacementTotals} from '@refra/modules/refra-static-parts/hooks'
import {StaticReplacementDTO} from '@refra/modules/refra-static-parts/types'

interface ShutdownDetailInfoProps {
  replacement?: StaticReplacementDTO
}

export const ShutdownDetailInfo = ({replacement}: ShutdownDetailInfoProps) => {
  const {t} = useTranslation()
  const [activeAreaIndex, setActiveAreaIndex] = useState(0)

  const materialInstallations = useMemo(
    () => replacement?.materialInstallations ?? [],
    [replacement]
  )

  const {areas} = useReplacementTotals(materialInstallations)
  const activeArea = areas[activeAreaIndex]

  const totalArea = activeArea?.totalArea ?? 0
  const totalWeight = activeArea?.totalWeight ?? 0
  const tableRows = activeArea?.layers ?? []

  return (
    <div className="flex flex-col gap-8">
      {materialInstallations.length > 1 && (
        <div className="flex gap-x-8 gap-y-4 flex-wrap px-4 py-3">
          {materialInstallations.map((_, index) => {
            const isActive = index === activeAreaIndex
            const color = StaticPartsColors[index % StaticPartsColors.length]
            return (
              <button
                key={index}
                type="button"
                className={clx(
                  `flex items-center gap-2 cursor-pointer pb-1 border-b-2 ${
                    isActive
                      ? 'text-primary border-current'
                      : 'text-foreground border-transparent hover:text-foreground_hover'
                  }`
                )}
                onClick={() => setActiveAreaIndex(index)}
              >
                <span
                  className="inline-block w-3 h-3 rounded-full"
                  style={{backgroundColor: color}}
                />
                <span className="text-sm font-medium">
                  {t('staticParts.editReplacement.sections.area', {index: index + 1})}
                </span>
              </button>
            )
          })}
        </div>
      )}
      <ShutdownDetailInfoSummary totalAreaSelected={totalArea} totalWeight={totalWeight} />
      <ShutdownDetailInfoTable rows={tableRows} />
    </div>
  )
}
